import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, Icon, IconButton } from '@chakra-ui/react';
import { useState } from 'react';
import { FaBars } from '@react-icons/all-files/fa/FaBars';
import { TuneSelector } from './components/TuneSelector';
export const TuneSelectorButton = ({ tunes, onTune = () => { }, activeTunes = [], children, ...iconButtonProps }) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggleOpen = () => {
        setIsOpen(!isOpen);
    };
    return (_jsxs(Flex, { pos: "relative", children: [_jsx(IconButton, { variant: 'field-highlighter-tooltip', onClick: toggleOpen, ...iconButtonProps, children: children ?? (_jsx(Icon, { asChild: true, children: _jsx(FaBars, {}) })) }), isOpen && (_jsx(Box, { position: "absolute", top: "6", left: "0", zIndex: "popover", p: "2", children: _jsx(TuneSelector, { tunes: tunes, onTune: onTune, activeTunes: activeTunes, onClose: () => {
                        setIsOpen(false);
                    } }) }))] }));
};
